function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39216 2.50049H17.6087C17.9527 2.50049 18.1258 2.94523 17.8946 3.22186L10.8676 10.7075V16.8564H13.2731C13.7267 16.8564 14.0522 17.248 14.0522 17.6785C14.0522 18.109 13.7267 18.5005 13.2731 18.5005H6.72749C6.27457 18.5005 5.94727 18.1097 5.94727 17.6785C5.94727 17.2473 6.27457 16.8564 6.72749 16.8564H9.13298V10.7084L2.10514 3.22186C1.87399 2.94523 2.04818 2.50049 2.39216 2.50049ZM15.112 3.84427H4.88662C4.67847 3.84427 4.56892 4.11374 4.71134 4.27947C4.91053 4.51067 5.12077 4.7557 5.33226 5.00218C5.41853 5.10272 5.50501 5.20351 5.59103 5.3037C5.8156 5.56363 6.12782 5.71148 6.45538 5.71148H13.5444C13.8719 5.71148 14.1852 5.56363 14.4087 5.3037C14.5486 5.14082 14.6896 4.97662 14.829 4.81434C14.9856 4.6321 15.1401 4.45228 15.2884 4.27947C15.4308 4.11374 15.3202 3.84427 15.112 3.84427Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBar);
export default __webpack_public_path__ + "static/media/icon-bar.c1ede970f6dff740f7447bb266260efa.svg";
export { ForwardRef as ReactComponent };